import { addSideEffects, initAction } from '@poa/state';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deletePreset,
  fetch,
  refreshTransfers,
  saveColumnPreset
} from './transfers.actions';

const transfersAvailablePresets = 'transfersAvailablePresets-v1';
const transfersLastSelectedPreset = 'transfersLastSelectedPreset-v1';

addSideEffects(fetch, async (payload, { actions, env }) => {
  try {
    const transfers = await env.api.transfers.fetch(payload.fetchType, [], 1, payload.sortingMap);

    actions.transfersActions.fetchSuccess(transfers);
  } catch (e) {
    console.error(e);
    actions.transfersActions.fetchFailed();
    throw e;
  }
});

addSideEffects(
  refreshTransfers,
  async ({ filters, page, fetchType, sortingMap, search }, { actions, env }) => {
    try {
      const transfers = await env.api.transfers.fetch(
        fetchType,
        filters.map(filter => ({ type: filter.type, value: filter.value })),
        page,
        sortingMap,
        search
      );
      actions.transfersActions.fetchSuccess(transfers);
    } catch (e) {
      console.error(e);
      actions.transfersActions.fetchFailed();
      throw e;
    }
  }
);

addSideEffects(saveColumnPreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.transfers.filters.columnSettings;

  await env.storage.setItem(transfersAvailablePresets, clone(availablePresets));
  await env.storage.setItem(transfersLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.transfers.filters.columnSettings;

  await env.storage.setItem(transfersAvailablePresets, clone(availablePresets));
  await env.storage.setItem(transfersLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async (_, { env, store }) => {
  const { currentPresetId } = store.transfers.filters.columnSettings;

  await env.storage.setItem(transfersLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(transfersAvailablePresets);
  const currentPresetId = await env.storage.getItem(transfersLastSelectedPreset);

  if (availablePresets && currentPresetId) {
    actions.transfersActions.resetColumnSettings({ presetId: currentPresetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.transfersActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.transfersActions.resetColumnSettings({
    presetId: store.transfers.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.transfers.filters.columnSettings.availablePresets
  });
});
